<template>
  <div class="application">
    <div class="application-box">
      <div class="application-title">申请试用</div>
      <div class="application-test">
        <div class="application-test-one">
          <div class="application-img-box">
            <div class="application-img">
              <img class="application-img-one" src="../assets/img/one-bg.png" />
              <img class="application-img-middle" src="../assets/img/one-middle.png" />
            </div>
            <div class="application-title-one">专人演示解答</div>
          </div>
          <div class="application-img-box">
            <div class="application-img">
              <img class="application-img-one" src="../assets/img/one-bg.png" />
              <img class="application-img-middle" src="../assets/img/two-middle.png" />
            </div>
            <div class="application-title-one">快速了解产品</div>
          </div>
          <div class="application-img-box">
            <div class="application-img">
              <img class="application-img-one" src="../assets/img/one-bg.png" />
              <img class="application-img-middle" src="../assets/img/three-middle.png" />
            </div>
            <div class="application-title-one">提供解决方案</div>
          </div>
        </div>
        <div class="application-test-two">
          <div class="application-test-content">
            <el-form :model="applicationModel" ref="applicationForm" :rules="validateRule">
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="provinceName" label=" ">
                    <el-select
                      v-model="applicationModel.provinceName"
                      clearable
                      placeholder="请选择省份"
                      style="width:310px"
                      @change="selectProvince"
                    >
                      <el-option
                        v-for="item in prov"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="cityName" label=" ">
                    <el-select
                      v-model="applicationModel.cityName"
                      clearable
                      placeholder="请选择城市"
                      style="width:300px"
                    >
                      <el-option
                        v-for="item in cityList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="applyUserName" label=" ">
                <el-input
                  v-model="applicationModel.applyUserName"
                  placeholder="请输入姓名"
                  style="width:650px"
                ></el-input>
              </el-form-item>
              <el-form-item prop="applyPhone" label=" ">
                <el-input
                  v-model="applicationModel.applyPhone"
                  placeholder="请输入联系方式"
                  style="width:650px"
                ></el-input>
              </el-form-item>
              <el-form-item prop="applyOrgName" label=" ">
                <el-input
                  v-model="applicationModel.applyOrgName"
                  placeholder="请输入公司名称"
                  style="width:650px"
                ></el-input>
              </el-form-item>
              <el-form-item prop="applyProducts" label=" ">
                <div class="product-box-test">
                  <div class="product-box-one" :class="{ 'active': !flag }" @click="toSelect">
                    评估端
                    <img src="../assets/img/disabled.png" v-if="flag" />
                    <img src="../assets/img/active.png" v-else />
                  </div>
                  <div
                    class="product-box-one"
                    :class="{ 'active': !flag1 }"
                    @click="toSelect1"
                    style="margin-left:13px"
                  >
                    全程端
                    <img src="../assets/img/disabled.png" v-if="flag1" />
                    <img src="../assets/img/active.png" v-else />
                  </div>
                  <div
                    class="product-box-one"
                    :class="{ 'active': !flag2 }"
                    @click="toSelect2"
                    style="margin-left:13px"
                  >
                    智慧征收系统
                    <img src="../assets/img/disabled.png" v-if="flag2" />
                    <img src="../assets/img/active.png" v-else />
                  </div>
                  <div
                    class="product-box-one"
                    :class="{ 'active': !flag3 }"
                    @click="toSelect3"
                    style="margin-left:13px"
                  >
                    GIS资产平台
                    <img src="../assets/img/disabled.png" v-if="flag3" />
                    <img src="../assets/img/active.png" v-else />
                  </div>
                </div>
                <!-- <div style="color: #F56C6C;font-size: 12px;" v-if="showFlag">申请产品不能为空！</div> -->
              </el-form-item>
            </el-form>
            <div class="submit-btn" @click="add('applicationForm')">提交申请</div>
          </div>
        </div>
      </div>
    </div>
    <div class="application-content"></div>
  </div>
</template>
<script>
import axios from 'axios';
import {
  getProvinceList,
  getCityList,
  applyTrial
} from '../api/publicinquiry.api.js';
export default {
  data() {
    var validateProjectName = function(rule, value, callback) {
      var pattern = /^1\d{10}$/;
      if (value === '') {
        callback(new Error('联系方式不能为空'));
        return false;
      } else {
        if (!pattern.test(value)) {
          callback(new Error('请输入合法的手机号'));
          return false;
        }
      }
      callback();
    };
    return {
      applicationModel: {
        provinceName: '',
        cityName: '',
        applyUserName: '',
        applyPhone: '',
        applyOrgName: '',
        applyProducts: ''
      },
      testList: [],
      prov: [],
      cityList: [],
      flag: true,
      flag1: true,
      flag2: true,
      flag3: true,
      showFlag: false,
      validateRule: {
        provinceName: [
          {
            required: true,
            message: '省份不能为空',
            trigger: ['blur', 'change']
          }
        ],
        cityName: [
          {
            required: true,
            message: '城市不能为空',
            trigger: ['blur', 'change']
          }
        ],
        applyUserName: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur'
          }
        ],
        applyPhone: [
          {
            required: true,
            message: '联系方式不能为空',
            trigger: 'blur'
          },
          { validator: validateProjectName, trigger: 'blur' }
        ],
        applyOrgName: [
          {
            required: true,
            message: '公司名称不能为空',
            trigger: 'blur'
          }
        ],
        applyProducts: [
          {
            required: true,
            message: '公司名称不能为空',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    toSelect() {
      this.flag = !this.flag;
      if (!this.flag) {
        this.showFlag = false;
        this.$refs.applicationForm.clearValidate('applyProducts');
      }
    },
    toSelect1() {
      this.flag1 = !this.flag1;
      if (!this.flag1) {
        this.showFlag = false;
        this.$refs.applicationForm.clearValidate('applyProducts');
      }
    },
    toSelect2() {
      this.flag2 = !this.flag2;
      if (!this.flag2) {
        this.showFlag = false;
        this.$refs.applicationForm.clearValidate('applyProducts');
      }
    },
    toSelect3() {
      this.flag3 = !this.flag3;
      if (!this.flag3) {
        this.showFlag = false;
        this.$refs.applicationForm.clearValidate('applyProducts');
      }
    },
    getProvinceList() {
      getProvinceList().then(res => {
        this.prov = res;
      });
    },
    selectProvince(val) {
      this.applicationModel.cityName = '';
      var v = this.prov.find((item, idnex) => {
        return val == item.id;
      });
      this.applicationModel.provinceName = v.name;
      getCityList(val).then(res => {
        this.cityList = res;
      });
    },
    add(formName) {
      this.applicationModel.applyProducts = '';
      if (!this.flag) {
        this.applicationModel.applyProducts =
          this.applicationModel.applyProducts + '评估端' + ';';
      }
      if (!this.flag1) {
        this.applicationModel.applyProducts =
          this.applicationModel.applyProducts + '全程端' + ';';
      }
      if (!this.flag2) {
        this.applicationModel.applyProducts =
          this.applicationModel.applyProducts + '智慧征收系统' + ';';
      }
      if (!this.flag3) {
        this.applicationModel.applyProducts =
          this.applicationModel.applyProducts + 'GIS资产平台平台' + ';';
      }
      this.$refs[formName].validate(valid => {
        if (valid && this.applicationModel.applyProducts) {
          applyTrial(this.applicationModel).then(res => {
            this.$message({
              message: '提交成功，我们将尽快派专人与您联系！',
              type: 'success'
            });
            this.$refs[formName].resetFields();
            this.flag = true;
            this.flag1 = true;
            this.flag2 = true;
            this.flag3 = true;
          });
        } else {
          this.showFlag = true;
          // console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created() {
    this.getProvinceList();
  }
};
</script>
<style>
.application {
  width: 100%;
}
.application-box {
  position: relative;
  height: 318px;
  background: rgb(0, 189, 183);
}
.application-title {
  width: 1500px;
  margin: auto;
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 48px;
  color: #ffffff;
  text-align: center;
  padding-top: 100px;
}
.application-test {
  position: absolute;
  right: 0;
  left: 0;
  top: 186px;
  margin: auto;
  width: 1200px;
  height: 700px;
  /* display: flex;
  background: red; */
}
.application-content {
  width: 1500px;
  margin: auto;
  height: 721px;
  background: #ffffff;
  display: flex;
}
.application-test-one {
  height: 200px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(204, 204, 204, 1);
  border-radius: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  display: flex;
}
.application-test-two {
  height: 547px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(204, 204, 204, 1);
  border-radius: 0px;
}
.application-img-box {
  margin-top: 32px;
  margin-left: 195px;
  width: 130px;
  height: 136px;
  text-align: center;
}
.application-img-one {
  width: 100px;
  height: 100px;
}
.application-img {
  position: relative;
}
.application-title-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #495362;
  text-align: center;
  margin-top: 5px;
}
.application-img-middle {
  position: absolute;
  width: 56px;
  height: 56px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.application-test-content {
  width: 700px;
  margin: auto;
  margin-top: 75px;
}
.product-box-test {
  display: flex;
  width: 650px;
  height: 50px;
}
.product-box-one {
  position: relative;
  cursor: pointer;
  width: 150px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #333333;
  border: 1px solid rgba(204, 204, 204, 1);
}
.product-box-one img {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 0;
  bottom: 0;
}
.el-input__inner {
  border: 1px solid rgba(204, 204, 204, 1);
  height: 50px;
}
.active {
  border: 2px solid rgba(0, 189, 183, 1);
}
.submit-btn {
  cursor: pointer;
  width: 110px;
  height: 40px;
  border: 1px solid rgba(0, 189, 183, 1);
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  color: #00bdb7;
  margin: auto;
}
.submit-btn:hover {
  background: rgba(0, 189, 183, 1);
  color: #ffffff;
}
.el-form-item__error {
  margin-left: 20px;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .application-title,
  .application-content {
    width: 1200px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application.vue